exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spn-create {\r\n  margin-left: 15px;\r\n  vertical-align: middle;\r\n}\r\n.btn-create-icon {\r\n  background-image: url('/assets/images/svg/icon_new_doc_white.svg');\r\n}\r\n.btn-create-icon:hover {\r\n  background-image: url('/assets/images/svg/icon_new_doc_white.svg');\r\n}\r\n.btn-create-icon:disabled{\r\n  background-image: url('/assets/images/svg/icon_new_doc_white.svg');\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/button/button-panel-header/button-panel-header.component.css
// module id = ../../../../../src/app/shared/button/button-panel-header/button-panel-header.component.css
// module chunks = main